import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.map";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import PropTypes, { array, object } from 'prop-types';
import React, { Component } from 'react';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import kebabCase from 'lodash/kebabCase';
import get from 'lodash/get';
import rehypeReact from 'rehype-react';
import { Helmet } from 'react-helmet';
import { FacebookShareButton, FacebookIcon, TwitterShareButton, TwitterIcon, PocketShareButton, PocketIcon, EmailShareButton, EmailIcon } from 'react-share';
import LazyLoad from 'react-lazyload';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var propTypes = {
  name: PropTypes.string.isRequired,
  siteUrl: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  socialUrls: PropTypes.array.isRequired,
  description: PropTypes.string.isRequired
};

var JsonLdWebSite = /*#__PURE__*/function () {
  function JsonLdWebSite() {
    _classCallCheck(this, JsonLdWebSite);
  }

  _createClass(JsonLdWebSite, null, [{
    key: "generate",
    value: function generate(name, siteUrl, logoUrl, socialUrls, description) {
      PropTypes.checkPropTypes(propTypes, {
        "name": name,
        "siteUrl": siteUrl,
        "logoUrl": logoUrl,
        "description": description,
        "socialUrls": socialUrls
      }, 'prop', 'JsonLdWebSite');
      var json = {
        "@context": "http://schema.org",
        "@type": "WebSite",
        "@id": siteUrl + "/#website",
        "url": siteUrl,
        "name": name,
        "image": logoUrl,
        "inLanguage": "en-GB",
        "description": description,
        "isFamilyFriendly": "http://schema.org/True",
        "contentRating": "NR",
        "publisher": {
          "@id": siteUrl + "#organization"
        },
        "mainEntity": {
          "@id": siteUrl + "#organization"
        },
        "hasPart": [{
          "@context": "http://schema.org/",
          "@type": "WPHeader",
          "@id": siteUrl + "#header",
          "headline": "headline-string"
        }],
        "sameAs": socialUrls
      };
      return json;
    }
  }]);

  return JsonLdWebSite;
}();

var propTypes$1 = {
  name: PropTypes.string.isRequired,
  siteUrl: PropTypes.string.isRequired,
  socialUrls: PropTypes.array.isRequired,
  logoUrl: PropTypes.string.isRequired,
  logoHeight: PropTypes.string.isRequired,
  logoWidth: PropTypes.string.isRequired
};

var JsonLdOrganization = /*#__PURE__*/function () {
  function JsonLdOrganization() {
    _classCallCheck(this, JsonLdOrganization);
  }

  _createClass(JsonLdOrganization, null, [{
    key: "generate",
    value: function generate(name, siteUrl, socialUrls, logoUrl, logoHeight, logoWidth) {
      PropTypes.checkPropTypes(propTypes$1, {
        "name": name,
        "siteUrl": siteUrl,
        "socialUrls": socialUrls,
        "logoUrl": logoUrl,
        "logoHeight": logoHeight,
        "logoWidth": logoWidth
      }, 'prop', 'JsonLdOrganization');
      var json = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "@id": siteUrl + "/#organization",
        "name": name,
        "url": siteUrl,
        "sameAs": socialUrls,
        "logo": {
          "@type": "ImageObject",
          "url": logoUrl,
          "width": logoWidth,
          "height": logoHeight
        }
      };
      return json;
    }
  }]);

  return JsonLdOrganization;
}();

var propTypes$2 = {
  siteUrl: PropTypes.string.isRequired,
  links: PropTypes.array.isRequired
};

var JsonLdSiteNavigation = /*#__PURE__*/function () {
  function JsonLdSiteNavigation() {
    _classCallCheck(this, JsonLdSiteNavigation);
  }

  _createClass(JsonLdSiteNavigation, null, [{
    key: "generate",
    value: function generate(siteUrl, links) {
      PropTypes.checkPropTypes(propTypes$2, {
        "siteUrl": siteUrl,
        "links": links
      }, 'prop', 'JsonLdOrganization');
      var siteNavigationElements = [];

      for (var i = 0; i < links.length; i++) {
        siteNavigationElements.push({
          "@context": "https://schema.org",
          "@type": "SiteNavigationElement",
          "@id": siteUrl + "/#header",
          "name": links[i].name,
          "url": links[i].url
        });
      }

      var json = {
        "@context": "https://schema.org",
        "@graph": siteNavigationElements
      };
      return json;
    }
  }]);

  return JsonLdSiteNavigation;
}();

var propTypes$3 = {
  siteUrl: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  dateCreated: PropTypes.string.isRequired,
  datePublished: PropTypes.string.isRequired,
  dateModified: PropTypes.string.isRequired,
  authorName: PropTypes.string.isRequired,
  publisherName: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  logoWidth: PropTypes.string.isRequired,
  logoHeight: PropTypes.string.isRequired
};

var JsonLdArticle = /*#__PURE__*/function () {
  function JsonLdArticle() {
    _classCallCheck(this, JsonLdArticle);
  }

  _createClass(JsonLdArticle, null, [{
    key: "generate",
    value: function generate(siteUrl, image, url, headline, dateCreated, datePublished, dateModified, authorName, publisherName, logoUrl, logoWidth, logoHeight) {
      PropTypes.checkPropTypes(propTypes$3, {
        "siteUrl": siteUrl,
        "image": image,
        "url": url,
        "headline": headline,
        "dateCreated": dateCreated,
        "datePublished": datePublished,
        "dateModified": dateModified,
        "authorName": authorName,
        "publisherName": publisherName,
        "logoUrl": logoUrl,
        "logoWidth": logoWidth,
        "logoHeight": logoHeight
      }, 'prop', 'JsonLdArticle');
      var json = {
        "@context": "http://schema.org",
        "@type": "Article",
        "image": image,
        "url": url,
        "headline": headline,
        "dateCreated": dateCreated,
        "datePublished": datePublished,
        "dateModified": dateModified,
        "inLanguage": "en-GB",
        "isFamilyFriendly": "true",
        "author": {
          "@type": "Person",
          "name": authorName
        },
        "creator": {
          "@type": "Person",
          "name": authorName
        },
        "publisher": {
          "@type": "Organization",
          "name": publisherName,
          "logo": {
            "@type": "ImageObject",
            "url": logoUrl,
            "width": logoWidth,
            "height": logoHeight
          }
        },
        "mainEntityOfPage": "True"
      };
      return json;
    }
  }]);

  return JsonLdArticle;
}();

var propTypes$4 = {
  links: PropTypes.array.isRequired
};

var JsonLdItemList = /*#__PURE__*/function () {
  function JsonLdItemList() {
    _classCallCheck(this, JsonLdItemList);
  }

  _createClass(JsonLdItemList, null, [{
    key: "generate",
    value: function generate(links) {
      PropTypes.checkPropTypes(propTypes$4, {
        "links": links
      }, 'prop', 'JsonLdOrganization');
      var itemListElements = [];

      for (var i = 0; i < links.length; i++) {
        itemListElements.push({
          "@type": "ListItem",
          "position": i,
          "url": links[i]
        });
      }

      var json = {
        "@context": "https://schema.org",
        "@type": "ItemList",
        "itemListElement": itemListElements
      };
      return json;
    }
  }]);

  return JsonLdItemList;
}();

var propTypes$5 = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
};

var JsonLdPerson = /*#__PURE__*/function () {
  function JsonLdPerson() {
    _classCallCheck(this, JsonLdPerson);
  }

  _createClass(JsonLdPerson, null, [{
    key: "generate",
    value: function generate(name, url) {
      PropTypes.checkPropTypes(propTypes$5, {
        "name": name,
        "url": url
      }, 'prop', 'JsonLdPerson');
      var json = {
        "@type": "Person",
        "name": name,
        "url": url
      };
      return json;
    }
  }]);

  return JsonLdPerson;
}();

var propTypes$6 = {
  datePublished: PropTypes.string.isRequired,
  dateModified: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  author: PropTypes.string.isRequired,
  rating: PropTypes.string.isRequired,
  bestRating: PropTypes.string.isRequired,
  organisation: PropTypes.string.isRequired
};

var JsonLdReview = /*#__PURE__*/function () {
  function JsonLdReview() {
    _classCallCheck(this, JsonLdReview);
  }

  _createClass(JsonLdReview, null, [{
    key: "generate",
    value: function generate(datePublished, dateModified, image, productName, author, rating, bestRating, organisation) {
      PropTypes.checkPropTypes(propTypes$6, {
        "datePublished": datePublished,
        "dateModified": dateModified,
        "image": image,
        "name": productName,
        "author": author,
        "ratingValue": rating,
        "bestRating": bestRating,
        "publisher": organisation
      }, 'prop', 'JsonLdReview');
      var json = {
        "@context": "https://schema.org",
        "@type": "Review",
        "datePublished": datePublished,
        "dateModified": dateModified,
        "image": image,
        "itemReviewed": {
          "@type": "Thing",
          "name": productName
        },
        "author": author,
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": rating,
          "bestRating": bestRating
        },
        "publisher": organisation
      };
      return json;
    }
  }]);

  return JsonLdReview;
}();

var propTypes$7 = {
  siteUrl: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  dateCreated: PropTypes.string.isRequired,
  datePublished: PropTypes.string.isRequired,
  dateModified: PropTypes.string.isRequired,
  authorName: PropTypes.string.isRequired,
  publisherName: PropTypes.string.isRequired,
  logoUrl: PropTypes.string.isRequired,
  logoWidth: PropTypes.string.isRequired,
  logoHeight: PropTypes.string.isRequired
};

var JsonLdProduct = /*#__PURE__*/function () {
  function JsonLdProduct() {
    _classCallCheck(this, JsonLdProduct);
  }

  _createClass(JsonLdProduct, null, [{
    key: "generate",
    value: function generate(image, brand, longTitle, description, rating, url, dateModified, authorName, publisherName, logoUrl, logoWidth, logoHeight) {
      PropTypes.checkPropTypes(propTypes$7, {
        "image": image,
        "url": url,
        "dateModified": dateModified,
        "authorName": authorName,
        "publisherName": publisherName,
        "logoUrl": logoUrl,
        "logoWidth": logoWidth,
        "logoHeight": logoHeight,
        "brand": brand,
        "longTitle": longTitle,
        "description": description,
        "rating": rating
      }, 'prop', 'JsonLdProduct');
      var json = {
        "@context": "https://schema.org",
        "@type": "Product",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": url
        },
        "brand": {
          "@type": "Brand",
          "name": brand
        },
        "image": image,
        "description": description,
        "name": brand + " " + longTitle,
        "review": {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": authorName
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": rating.toString(),
            "bestRating": "5",
            "worstRating": "1"
          },
          "publisher": {
            "@type": "Organization",
            "name": publisherName,
            "logo": {
              "@type": "ImageObject",
              "url": logoUrl,
              "width": logoWidth,
              "height": logoHeight
            }
          }
        }
      };
      return json;
    }
  }]);

  return JsonLdProduct;
}();

var PostDate = /*#__PURE__*/function (_React$Component) {
  _inherits(PostDate, _React$Component);

  function PostDate() {
    _classCallCheck(this, PostDate);

    return _possibleConstructorReturn(this, _getPrototypeOf(PostDate).apply(this, arguments));
  }

  _createClass(PostDate, [{
    key: "render",
    value: function render() {
      var dateLastModified = this.props.dateLastModified;
      return React.createElement("em", null, React.createElement("small", {
        className: "text-muted"
      }, React.createElement("span", null, "Last Updated: "), React.createElement("time", {
        dateTime: dateLastModified
      }, dateLastModified)));
    }
  }]);

  return PostDate;
}(React.Component);

var AuthorProfileLink = /*#__PURE__*/function (_React$Component) {
  _inherits(AuthorProfileLink, _React$Component);

  function AuthorProfileLink() {
    _classCallCheck(this, AuthorProfileLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(AuthorProfileLink).apply(this, arguments));
  }

  _createClass(AuthorProfileLink, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          authorSlug = _this$props.authorSlug,
          authorName = _this$props.authorName;

      if (authorSlug !== undefined && authorName !== undefined) {
        return React.createElement("div", {
          className: "authorLink"
        }, React.createElement(Link, {
          to: authorSlug
        }, authorName));
      } else {
        return React.createElement("div", null);
      }
    }
  }]);

  return AuthorProfileLink;
}(React.Component);

var PLACEHOLDER_CURRENT_YEAR = "{{CURRENT_YEAR}}";

function replacePlaceholders(string) {
  var result;
  string = string;

  if (string && typeof string === "string") {
    result = string.replace(new RegExp(PLACEHOLDER_CURRENT_YEAR, "gi"), new Date().getFullYear());
  }

  return result;
}

var SitePostSummary = /*#__PURE__*/function (_React$Component) {
  _inherits(SitePostSummary, _React$Component);

  function SitePostSummary() {
    _classCallCheck(this, SitePostSummary);

    return _possibleConstructorReturn(this, _getPrototypeOf(SitePostSummary).apply(this, arguments));
  }

  _createClass(SitePostSummary, [{
    key: "getAuthorNames",
    value: function getAuthorNames(authors) {
      var authorNames = [];
      authorNames.push(React.createElement("span", {
        key: 0
      }, "Written by: "));
      authors.forEach(function (author, index) {
        authorNames.push(author.name);

        if (index < authors.length - 1) {
          authorNames.push(React.createElement("span", {
            key: index + 1
          }, " and "));
        }
      });
      return authorNames;
    }
  }, {
    key: "getVerticleLayout",
    value: function getVerticleLayout(title, slug, datePublished, dateLastModified, description, shareImage, authors) {
      return React.createElement("div", {
        className: "post-summary py-3"
      }, React.createElement(Link, {
        to: slug
      }, React.createElement("div", {
        className: "row align-items-center no-gutters"
      }, React.createElement("div", {
        className: "col-sm-3 p-3"
      }, React.createElement(Img, {
        fixed: shareImage,
        imgStyle: {
          objectFit: "contain"
        }
      })), React.createElement("div", {
        className: "col-sm-9 p-3"
      }, React.createElement("h3", {
        className: "card-title text-left display-6"
      }, title), description ? React.createElement("p", {
        className: "card-text text-justify"
      }, description) : null)), React.createElement("div", {
        className: "row align-items-center no-gutters"
      }, React.createElement("div", {
        className: "col-12 px-3"
      }, React.createElement("p", {
        className: "card-text text-right"
      }, React.createElement("em", null, React.createElement("small", {
        className: "text-muted"
      }, this.getAuthorNames(authors), React.createElement("span", null, ", "))), dateLastModified ? React.createElement(PostDate, {
        dateLastModified: dateLastModified
      }) : null)))));
    }
  }, {
    key: "getHorizontalLayout",
    value: function getHorizontalLayout(title, slug, shareImage, dateLastModified, description) {
      return React.createElement("div", {
        className: "post-summary card"
      }, React.createElement(Link, {
        to: slug
      }, React.createElement(Img, {
        className: "card-img-top",
        fixed: shareImage,
        imgStyle: {
          objectFit: "contain"
        }
      }), React.createElement("div", {
        className: "card-body"
      }, dateLastModified ? React.createElement(PostDate, {
        dateLastModified: dateLastModified
      }) : null, React.createElement("h3", {
        className: "card-title display-6"
      }, title), description ? React.createElement("p", {
        className: "card-text text-justify"
      }, description) : null)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          horizontal = _this$props.horizontal,
          title = _this$props.title,
          slug = _this$props.slug,
          authors = _this$props.authors,
          datePublished = _this$props.datePublished,
          dateLastModified = _this$props.dateLastModified,
          description = _this$props.description,
          shareImage = _this$props.shareImage;
      var modifiedTitle = replacePlaceholders(title);
      var modifiedDescription = replacePlaceholders(description);

      if (horizontal) {
        return this.getHorizontalLayout(modifiedTitle, slug, shareImage, dateLastModified, modifiedDescription);
      } else {
        return this.getVerticleLayout(modifiedTitle, slug, datePublished, dateLastModified, modifiedDescription, shareImage, authors);
      }
    }
  }]);

  return SitePostSummary;
}(React.Component);

var TextPostSummary = /*#__PURE__*/function (_React$Component) {
  _inherits(TextPostSummary, _React$Component);

  function TextPostSummary() {
    _classCallCheck(this, TextPostSummary);

    return _possibleConstructorReturn(this, _getPrototypeOf(TextPostSummary).apply(this, arguments));
  }

  _createClass(TextPostSummary, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          slug = _this$props.slug;
      return React.createElement("div", {
        className: "text-post-summary"
      }, React.createElement(Link, {
        to: slug
      }, React.createElement("div", {
        className: "col-12"
      }, React.createElement("h5", {
        className: "card-title text-left"
      }, title), React.createElement("hr", null))));
    }
  }]);

  return TextPostSummary;
}(React.Component);

var LeadParagraph = /*#__PURE__*/function (_React$Component) {
  _inherits(LeadParagraph, _React$Component);

  function LeadParagraph() {
    _classCallCheck(this, LeadParagraph);

    return _possibleConstructorReturn(this, _getPrototypeOf(LeadParagraph).apply(this, arguments));
  }

  _createClass(LeadParagraph, [{
    key: "render",
    value: function render() {
      return React.createElement("p", {
        className: "lead py-3"
      }, React.createElement("strong", null, this.props.children));
    }
  }]);

  return LeadParagraph;
}(React.Component);

var AffiliateBuyButton = /*#__PURE__*/function (_React$Component) {
  _inherits(AffiliateBuyButton, _React$Component);

  function AffiliateBuyButton() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AffiliateBuyButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AffiliateBuyButton)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      var _this$props = _this.props,
          seller = _this$props.seller,
          productUrl = _this$props.productUrl,
          affiliateId = _this$props.affiliateId;
      e.preventDefault();

      if (window.fbq !== undefined) {
        window.fbq('track', 'Lead');
      } else {
        console.log("window.fbq('track', 'Lead')");
      }

      var openUrl = productUrl;

      switch (seller.toLowerCase()) {
        case 'amazon':
          openUrl += '?tag=';
          break;

        default:
          openUrl += '?tag=';
          break;
      }

      openUrl += affiliateId;
      window.open(openUrl, '_blank');
    });

    return _this;
  }

  _createClass(AffiliateBuyButton, [{
    key: "getSellerCssClass",
    value: function getSellerCssClass(seller, additionalCssClasses) {
      var cssClass = 'btn btn-rounded';
      cssClass += additionalCssClasses ? ' ' + additionalCssClasses : '';

      switch (seller.toLowerCase()) {
        case 'amazon':
          cssClass += ' btn-amazon';
          break;

        default:
          cssClass += ' btn-primary';
          break;
      }

      return cssClass;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          seller = _this$props2.seller,
          additionalCssClasses = _this$props2.additionalCssClasses;
      var cssClass = this.getSellerCssClass(seller, additionalCssClasses);
      return React.createElement("button", {
        onClick: this.onClick,
        className: cssClass
      }, this.props.children);
    }
  }]);

  return AffiliateBuyButton;
}(React.Component);

var InteralSectionLink = /*#__PURE__*/function (_React$Component) {
  _inherits(InteralSectionLink, _React$Component);

  function InteralSectionLink() {
    _classCallCheck(this, InteralSectionLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(InteralSectionLink).apply(this, arguments));
  }

  _createClass(InteralSectionLink, [{
    key: "render",
    value: function render() {
      var shortTitle = this.props.shortTitle;
      return React.createElement("a", {
        href: '#' + kebabCase(shortTitle)
      }, this.props.children);
    }
  }]);

  return InteralSectionLink;
}(React.Component);

var StarRating = /*#__PURE__*/function (_React$Component) {
  _inherits(StarRating, _React$Component);

  function StarRating() {
    _classCallCheck(this, StarRating);

    return _possibleConstructorReturn(this, _getPrototypeOf(StarRating).apply(this, arguments));
  }

  _createClass(StarRating, [{
    key: "createStars",
    value: function createStars(rating) {
      var elements = [];
      var remainder = rating % 1;
      var wholeStars = rating - remainder;

      if (remainder < 0.5) {
        remainder = 0;
      }

      for (var i = 1; i <= 5; i++) {
        if (i <= wholeStars) {
          elements.push(React.createElement("i", {
            className: "fa fa-star fa-2",
            key: i
          }));
        } else if (remainder !== 0 && i === wholeStars + 1) {
          elements.push(React.createElement("i", {
            className: "fa fa-star-half-o fa-2",
            key: i
          }));
        } else {
          elements.push(React.createElement("i", {
            className: "fa fa-star-o fa-2",
            key: i
          }));
        }
      }

      return elements;
    }
  }, {
    key: "render",
    value: function render() {
      var rating = this.props.rating;
      return React.createElement("span", {
        className: "star-rating px-1 px-sm-3"
      }, this.createStars(rating));
    }
  }]);

  return StarRating;
}(React.Component);

var RatingsComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(RatingsComponent, _React$Component);

  function RatingsComponent() {
    _classCallCheck(this, RatingsComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(RatingsComponent).apply(this, arguments));
  }

  _createClass(RatingsComponent, [{
    key: "createRatingElements",
    value: function createRatingElements(ratings, ratingCountToDisplay, horizontal) {
      var listItems = [];

      for (var index = 0; index < ratingCountToDisplay; index++) {
        var rating = ratings[index];

        if (rating) {
          if (horizontal) {
            listItems.push(this.createHorizontalLayout(index, rating.label, rating.value));
          } else {
            listItems.push(this.createVerticalLayout(index, rating.label, rating.value));
          }
        }
      }

      return listItems;
    }
  }, {
    key: "createHorizontalLayout",
    value: function createHorizontalLayout(index, label, value) {
      var listItemClass = index === 0 ? 'rating py-3' : 'rating py-1';
      return React.createElement("li", {
        key: index,
        className: listItemClass
      }, React.createElement("div", {
        className: "row no-gutters"
      }, React.createElement("div", {
        className: "col-6 text-right"
      }, React.createElement("span", {
        className: "rating-label"
      }, label)), React.createElement("div", {
        className: "col-6 text-left"
      }, React.createElement(StarRating, {
        rating: parseFloat(value)
      }))));
    }
  }, {
    key: "createVerticalLayout",
    value: function createVerticalLayout(index, label, value) {
      return React.createElement("li", {
        key: index,
        className: "rating"
      }, React.createElement("div", {
        className: "row no-gutters"
      }, React.createElement("div", {
        className: "col-12 text-center"
      }, React.createElement("span", {
        className: "rating-label"
      }, label))), React.createElement("div", {
        className: "row no-gutters"
      }, React.createElement("div", {
        className: "col-12 text-center"
      }, React.createElement(StarRating, {
        rating: parseFloat(value)
      }))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          ratings = _this$props.ratings,
          ratingCountToDisplay = _this$props.ratingCountToDisplay,
          horizontal = _this$props.horizontal;
      return this.createRatingElements(ratings, ratingCountToDisplay, horizontal);
    }
  }]);

  return RatingsComponent;
}(React.Component);

var components = {
  featureComparisonListItem: {
    ratingLabel: "Our Rating",
    affiliateButtonLabel: "Check Price"
  },
  roundupWinnerListItem: {
    affiliateButtonLabel: "Check Price"
  },
  roundupListItem: {
    affiliateButtonLabel: "Check Price"
  },
  productDetailedReview: {
    showLessMessage: "Read less ",
    showMoreMessage: "Read more "
  }
};

var RoundupWinner = /*#__PURE__*/function (_React$Component) {
  _inherits(RoundupWinner, _React$Component);

  function RoundupWinner() {
    _classCallCheck(this, RoundupWinner);

    return _possibleConstructorReturn(this, _getPrototypeOf(RoundupWinner).apply(this, arguments));
  }

  _createClass(RoundupWinner, [{
    key: "createCopyElements",
    value: function createCopyElements(copyParagraphs) {
      var elements = [];
      copyParagraphs.forEach(function (copyParagraph, index) {
        elements.push(React.createElement("p", {
          key: index
        }, copyParagraph.text));
      });
      return elements;
    }
  }, {
    key: "createListItemElements",
    value: function createListItemElements(items, icon) {
      var elements = [];
      var iconClass = "fa ".concat(icon, " fa-2");
      items.forEach(function (item, index) {
        elements.push(React.createElement("li", {
          key: index,
          className: "list-group-item"
        }, React.createElement("div", {
          className: "attribute-container"
        }, React.createElement("div", {
          className: "icons px-1 d-inline-block"
        }, React.createElement("i", {
          className: iconClass
        })), React.createElement("span", null, item))));
      });
      return elements;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          brand = _this$props.brand,
          shortTitle = _this$props.shortTitle,
          longTitle = _this$props.longTitle,
          topPickBadgeFluid = _this$props.topPickBadgeFluid,
          ratings = _this$props.ratings,
          winnerPros = _this$props.winnerPros,
          sellingPlatform = _this$props.sellingPlatform,
          buyingUrl = _this$props.buyingUrl,
          affiliateId = _this$props.affiliateId,
          productFluidImage = _this$props.productFluidImage;
      return React.createElement("div", {
        className: "roundup-winner card mt-3"
      }, React.createElement("div", {
        className: "card-body"
      }, React.createElement("div", {
        className: "row p-3"
      }, React.createElement("div", {
        className: "col-12 col-sm-7 text-sm-left text-center display-5"
      }, React.createElement("div", {
        className: "roundup-winner-badge"
      }, React.createElement(Img, {
        fluid: topPickBadgeFluid
      }))), React.createElement("div", {
        className: "col-12 col-sm-5 offset-lg-2 col-lg-3"
      }, React.createElement("hr", {
        className: "\td-block d-sm-none"
      }), React.createElement("ul", {
        className: "list-unstyled"
      }, React.createElement(RatingsComponent, {
        ratings: ratings,
        ratingCountToDisplay: 1,
        horizontal: false
      })))), React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-12"
      }, React.createElement("p", {
        className: "h2"
      }, brand, " ", shortTitle))), React.createElement("div", {
        className: "row align-items-start "
      }, React.createElement("div", {
        className: "offset-1 col-10 offset-sm-2 col-sm-8 offset-lg-0 col-lg-4 text-center"
      }, React.createElement(Img, {
        fluid: productFluidImage
      })), React.createElement("div", {
        className: "col-12 col-lg-8"
      }, React.createElement("ul", {
        className: "list-group list-group-flush"
      }, this.createListItemElements(winnerPros, "fa-check")))), React.createElement("div", {
        className: "row align-items-center py-3"
      }, React.createElement("div", {
        className: "col-12 text-center"
      }, React.createElement(InteralSectionLink, {
        shortTitle: shortTitle
      }, "Detailed Review", " ", React.createElement("i", {
        className: "fa fa-chevron-down",
        "aria-hidden": "true"
      })))), React.createElement("div", {
        className: "row align-items-center"
      }, React.createElement("div", {
        className: "col-12 align-middle text-center"
      }, React.createElement(AffiliateBuyButton, {
        seller: sellingPlatform,
        productUrl: buyingUrl,
        additionalCssClasses: "btn-lg btn-block btn-ruw",
        affiliateId: affiliateId
      }, components.featureComparisonListItem.affiliateButtonLabel)))));
    }
  }]);

  return RoundupWinner;
}(React.Component);

function convertKeyPairArrayToMap(keyPairArray) {
  var map = new Map();

  if (keyPairArray) {
    keyPairArray.forEach(function (keyPair) {
      map.set(keyPair.label, keyPair.value);
    });
  }

  return map;
}

function collectAttributeByString(product, attributeName) {
  var attributes = [];

  for (var i = 1; i <= 5; i++) {
    var label = get(product, "".concat(attributeName).concat(i, ".label"));
    var value = get(product, "".concat(attributeName).concat(i, "Value"));

    if (label && value) {
      attributes.push({
        label: label,
        value: value
      });
    }
  }

  return attributes;
}

function collectAttributesMap(product) {
  return convertKeyPairArrayToMap(collectAttributeByString(product, 'attribute'));
}

function collectRatings(product) {
  var ratings = collectAttributeByString(product, 'rating');
  var total = 0;
  ratings.forEach(function (rating) {
    return total += rating.value;
  });
  ratings.sort(function (a, b) {
    return a.label > b.label ? 1 : a.label < b.label ? -1 : 0;
  });

  if (total > 0) {
    ratings.unshift({
      label: "Our Rating",
      value: parseFloat(total / ratings.length)
    });
  } else {
    ratings.unshift({
      label: "Our Rating",
      value: 0
    });
  }

  return ratings;
}

var FeatureComparisonListItem = /*#__PURE__*/function (_React$Component) {
  _inherits(FeatureComparisonListItem, _React$Component);

  function FeatureComparisonListItem() {
    _classCallCheck(this, FeatureComparisonListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(FeatureComparisonListItem).apply(this, arguments));
  }

  _createClass(FeatureComparisonListItem, [{
    key: "createAttributeList",
    value: function createAttributeList(attributeMap, attributesToDisplay) {
      var attributeElements = [];
      attributesToDisplay.forEach(function (attributeToDisplay, index) {
        var attributeValue = attributeMap.get(attributeToDisplay.label);
        var classNames = "col-12 col-md-12 text-center text-md-center feature-attribute feature-attribute-".concat(index);
        attributeElements.push(React.createElement("div", {
          key: index,
          className: "row"
        }, React.createElement("div", {
          className: classNames
        }, React.createElement("span", null, attributeValue === undefined ? React.createElement("span", null, "-") : attributeValue))));
      });
      return attributeElements;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          product = _this$props.product,
          attributesToDisplay = _this$props.attributesToDisplay,
          rank = _this$props.rank,
          affiliateId = _this$props.affiliateId;
      var attributesMap = collectAttributesMap(product);
      var attributeItems = this.createAttributeList(attributesMap, attributesToDisplay);
      var ratings = collectRatings(product);
      return React.createElement("div", {
        className: "comparison-item"
      }, React.createElement("div", null, React.createElement("div", {
        className: "row text-center"
      }, React.createElement("div", {
        className: "col-12"
      }, React.createElement("span", {
        className: "h2"
      }, rank))), React.createElement("div", {
        className: "row comparison-thumbnail align-items-center text-center"
      }, React.createElement("div", {
        className: "col-12"
      }, product.images[0] ? React.createElement(Img, {
        fluid: product.images[0].fluid,
        style: {
          height: "200px"
        },
        imgStyle: {
          objectFit: "contain"
        }
      }) : React.createElement("div", null))), React.createElement("div", {
        className: "row text-center comparison-title"
      }, React.createElement("div", {
        className: "col-12"
      }, React.createElement("span", {
        className: "h2"
      }, product.shortTitle))), React.createElement("div", {
        className: "row text-center"
      }, React.createElement("div", {
        className: "col-12"
      }, React.createElement("div", {
        className: ""
      }, React.createElement("div", {
        className: ""
      }, React.createElement("span", null, ratings[0].ratingLabel)), React.createElement("div", {
        className: ""
      }, React.createElement("div", {
        className: "icons p-3"
      }, React.createElement(StarRating, {
        rating: parseFloat(ratings[0].value)
      })))))), React.createElement("div", {
        className: "row text-center py-3"
      }, React.createElement("div", {
        className: "col-12"
      }, React.createElement(AffiliateBuyButton, {
        productUrl: product.buyingUrl,
        seller: product.sellingPlatform,
        additionalCssClasses: "btn-fcli",
        affiliateId: affiliateId
      }, components.featureComparisonListItem.affiliateButtonLabel))), React.createElement("div", {
        className: "row text-center"
      }, React.createElement("div", {
        className: "col-12"
      }, attributeItems))));
    }
  }]);

  return FeatureComparisonListItem;
}(React.Component);

var FeatureComparisonTable = /*#__PURE__*/function (_React$Component) {
  _inherits(FeatureComparisonTable, _React$Component);

  function FeatureComparisonTable() {
    _classCallCheck(this, FeatureComparisonTable);

    return _possibleConstructorReturn(this, _getPrototypeOf(FeatureComparisonTable).apply(this, arguments));
  }

  _createClass(FeatureComparisonTable, [{
    key: "createAttributeLabels",
    value: function createAttributeLabels(attributesToDisplay) {
      var attributeLabels = [];
      attributesToDisplay.forEach(function (attribute, index) {
        var classNames = "col-12 feature-attribute-label feature-attribute-label-".concat(index);
        attributeLabels.push(React.createElement("div", {
          key: index,
          className: "row"
        }, React.createElement("div", {
          className: classNames
        }, React.createElement("span", null, attribute.label))));
      });
      return attributeLabels;
    }
  }, {
    key: "createTableDataRows",
    value: function createTableDataRows(products, attributesToDisplay) {
      var tableData = {
        ranks: [],
        images: [],
        shortTitles: [],
        buyingUrls: [],
        sellingPlatforms: [],
        ratings: [],
        attributes1: [],
        attributes2: [],
        attributes3: [],
        attributes4: [],
        attributes5: []
      };
      products.forEach(function (product, index) {
        var attributesMap = collectAttributesMap(product);
        var ratings = collectRatings(product);
        attributesToDisplay.forEach(function (attributeToDisplay, index) {
          var attributeValue = attributesMap.get(attributeToDisplay.label);
          tableData['attributes' + (index + 1)].push(attributeValue === undefined ? '-' : attributeValue);
        });
        tableData.ranks.push(index + 1);
        tableData.images.push(product.images[0].fluid);
        tableData.shortTitles.push(product.shortTitle);
        tableData.buyingUrls.push(product.buyingUrl);
        tableData.sellingPlatforms.push(product.sellingPlatform);
        tableData.ratings.push(ratings[0].value);
      });
      return tableData;
    }
  }, {
    key: "createFeatureComparisonTable",
    value: function createFeatureComparisonTable(tableData, affiliateId, attributesToDisplay) {
      var _this = this;

      var tableRows = [];
      tableRows.push(this.createTableHeadingRow('', tableData.ranks));
      tableRows.push(this.createTableImageRow('', tableData.images));
      tableRows.push(this.createTableBuyButtonRow('', tableData.buyingUrls, tableData.sellingPlatforms, affiliateId));
      tableRows.push(this.createTableRatingRow('', tableData.ratings));
      tableRows.push(this.createTableRow('', tableData.shortTitles));
      attributesToDisplay.forEach(function (attributesToDisplay, index) {
        tableRows.push(_this.createTableRow(attributesToDisplay.label, tableData['attributes' + (index + 1)]));
      });
      return React.createElement("table", {
        className: "table table-borderless feature-comparison-table"
      }, tableRows);
    }
  }, {
    key: "createTableRatingRow",
    value: function createTableRatingRow(heading, ratings) {
      var cells = [];
      ratings.forEach(function (rating, index) {
        cells.push(React.createElement("td", null, React.createElement(StarRating, {
          rating: parseFloat(rating)
        })));
      });
      return React.createElement("tr", null, React.createElement("th", {
        scope: "row"
      }, heading), cells);
    }
  }, {
    key: "createTableBuyButtonRow",
    value: function createTableBuyButtonRow(heading, buyingUrls, sellingPlatforms, affiliateId) {
      var cells = [];
      buyingUrls.forEach(function (buyingUrl, index) {
        cells.push(React.createElement("td", null, React.createElement(AffiliateBuyButton, {
          productUrl: buyingUrl,
          seller: sellingPlatforms[index],
          additionalCssClasses: "btn-fcli",
          affiliateId: affiliateId
        }, components.featureComparisonListItem.affiliateButtonLabel)));
      });
      return React.createElement("tr", null, React.createElement("th", {
        scope: "row"
      }, heading), cells);
    }
  }, {
    key: "createTableImageRow",
    value: function createTableImageRow(heading, values) {
      var cells = [];
      values.forEach(function (value, index) {
        cells.push(React.createElement("td", null, React.createElement(Img, {
          fluid: value,
          style: {
            height: "200px"
          },
          imgStyle: {
            objectFit: "contain"
          }
        })));
      });
      return React.createElement("tr", null, React.createElement("th", {
        scope: "row"
      }, heading), cells);
    }
  }, {
    key: "createTableRow",
    value: function createTableRow(heading, values) {
      var cells = [];
      values.forEach(function (value, index) {
        cells.push(React.createElement("td", null, value));
      });
      return React.createElement("tr", null, React.createElement("th", {
        scope: "row"
      }, heading), cells);
    }
  }, {
    key: "createTableHeadingRow",
    value: function createTableHeadingRow(heading, values) {
      var cells = [];
      values.forEach(function (value, index) {
        cells.push(React.createElement("th", {
          scope: "col"
        }, value));
      });
      return React.createElement("tr", null, React.createElement("th", {
        scope: "col"
      }, heading), cells);
    }
  }, {
    key: "createFeatureComparisonItems",
    value: function createFeatureComparisonItems(products, attributesToDisplay, affiliateId) {
      var listItems = [];
      products.forEach(function (product, index) {
        var productImage;
        listItems.push(React.createElement(FeatureComparisonListItem, {
          product: product,
          productImage: productImage,
          attributesToDisplay: attributesToDisplay,
          key: product.id + 'fcrli' + index,
          rank: index + 1,
          affiliateId: affiliateId
        }));
      });
      return listItems;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          products = _this$props.products,
          attributesToDisplay = _this$props.attributesToDisplay,
          affiliateId = _this$props.affiliateId;
      var tableData = this.createTableDataRows(products, attributesToDisplay);
      var comparisonTable = this.createFeatureComparisonTable(tableData, affiliateId, attributesToDisplay);
      return React.createElement("div", null, React.createElement("div", {
        className: "feature-comparison"
      }, comparisonTable), React.createElement("div", {
        className: "row mt-3 align-items-center text-center"
      }, React.createElement("div", {
        className: "col-12"
      }, React.createElement("span", {
        className: "align-middle display-6"
      }, "Scroll for more "), React.createElement("i", {
        className: "fa fa-arrow-right fa-3 animated-arrow align-middle",
        "data-emergence": "hidden"
      }))));
    }
  }]);

  return FeatureComparisonTable;
}(React.Component);

var ReadMoreTrigger = /*#__PURE__*/function (_React$Component) {
  _inherits(ReadMoreTrigger, _React$Component);

  function ReadMoreTrigger(props) {
    var _this;

    _classCallCheck(this, ReadMoreTrigger);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReadMoreTrigger).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "flipState", function () {
      var newState = !_this.state.isExpanded;

      _this.setState({
        isExpanded: newState
      });
    });

    _this.state = {
      isExpanded: false
    };
    return _this;
  }

  _createClass(ReadMoreTrigger, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          collapseId = _this$props.collapseId,
          showLessMessage = _this$props.showLessMessage,
          showMoreMessage = _this$props.showMoreMessage;
      var showMoreElement = React.createElement("span", null, showMoreMessage, React.createElement("i", {
        className: "fa fa-chevron-down",
        "aria-hidden": "true"
      }));
      var showLessElement = React.createElement("span", null, showLessMessage, React.createElement("i", {
        className: "fa fa-chevron-up",
        "aria-hidden": "true"
      }));
      return React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-12 text-center"
      }, React.createElement("a", {
        className: "read-more-trigger",
        "data-toggle": "collapse",
        href: '#' + collapseId,
        onClick: this.flipState
      }, this.state.isExpanded ? showLessElement : showMoreElement)));
    }
  }]);

  return ReadMoreTrigger;
}(React.Component);

var Tip = /*#__PURE__*/function (_React$Component) {
  _inherits(Tip, _React$Component);

  function Tip() {
    _classCallCheck(this, Tip);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tip).apply(this, arguments));
  }

  _createClass(Tip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          children = _this$props.children;
      return React.createElement("div", {
        className: "card tip my-3"
      }, React.createElement("div", {
        className: "card-body"
      }, React.createElement("h5", {
        className: "card-title"
      }, title), React.createElement("p", {
        className: "card-text"
      }, children)));
    }
  }]);

  return Tip;
}(React.Component);

var ProductDetailedReview = /*#__PURE__*/function (_React$Component) {
  _inherits(ProductDetailedReview, _React$Component);

  function ProductDetailedReview() {
    _classCallCheck(this, ProductDetailedReview);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductDetailedReview).apply(this, arguments));
  }

  _createClass(ProductDetailedReview, [{
    key: "createCopyElements",
    value: function createCopyElements(copyParagraphs) {
      var elements = [];
      copyParagraphs.forEach(function (copyParagraph, index) {
        elements.push(React.createElement("p", {
          key: index
        }, copyParagraph.text));
      });
      return elements;
    }
  }, {
    key: "createListItemElements",
    value: function createListItemElements(items, icon, keyPrefix) {
      var elements = [];
      var iconClass = "fa ".concat(icon, " fa-2");
      items.forEach(function (item, index) {
        elements.push(React.createElement("li", {
          key: keyPrefix + index,
          className: "list-group-item"
        }, React.createElement("div", {
          className: "attribute-container"
        }, React.createElement("div", {
          className: "icons px-1 d-inline-block"
        }, React.createElement("i", {
          className: iconClass
        })), React.createElement("span", null, item))));
      });
      return elements;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          rank = _this$props.rank,
          topPickBadge = _this$props.topPickBadge,
          productId = _this$props.productId,
          shortTitle = _this$props.shortTitle,
          longTitle = _this$props.longTitle,
          brand = _this$props.brand,
          awardLabel = _this$props.awardLabel,
          productFixedImage = _this$props.productFixedImage,
          affiliateId = _this$props.affiliateId,
          ratings = _this$props.ratings,
          introHtmlAst = _this$props.introHtmlAst,
          fullCopyHtmlAst = _this$props.fullCopyHtmlAst,
          pros = _this$props.pros,
          cons = _this$props.cons,
          sellingPlatform = _this$props.sellingPlatform,
          buyingUrl = _this$props.buyingUrl;
      var renderAst = new rehypeReact({
        createElement: React.createElement,
        components: {
          tip: Tip,
          leadparagraph: LeadParagraph
        }
      }).Compiler;
      var collapseId = 'collapse_' + productId;
      return React.createElement("div", {
        className: "product-summary card mt-3 mb-5"
      }, React.createElement("div", {
        className: "card-header text-white bg-primary h2 rounded-top p-4"
      }, '#' + rank + ' ' + shortTitle + (awardLabel ? ' - ' + awardLabel : '')), React.createElement("div", {
        className: "card-body"
      }, React.createElement("div", {
        className: "row p-3 align-items-center "
      }, React.createElement("div", {
        className: "offset-8 col-4 offset-sm-9 col-sm-3 offset-md-10 col-md-2 text-center"
      }, React.createElement("div", {
        className: "roundup-winner-badge"
      }, rank === 1 ? React.createElement(Img, {
        fluid: topPickBadge
      }) : null))), React.createElement("div", {
        className: "row align-items-center mb-5"
      }, React.createElement("div", {
        className: "offset-1 col-10 offset-sm-2 col-sm-8 offset-lg-0 col-lg-4 text-center"
      }, React.createElement(Img, {
        fluid: productFixedImage,
        style: {
          maxHeight: "300px"
        },
        imgStyle: {
          objectFit: "contain"
        }
      })), React.createElement("div", {
        className: "col-12 col-lg-8 mt-3"
      }, React.createElement("hr", {
        className: "\td-block d-sm-none"
      }), React.createElement("ul", {
        className: "list-unstyled"
      }, React.createElement(RatingsComponent, {
        ratings: ratings,
        ratingCountToDisplay: 5,
        horizontal: true
      })))), React.createElement("div", {
        className: "row align-items-start"
      }, React.createElement("div", {
        className: "col-12"
      }, React.createElement("h2", null, brand + ' ' + longTitle), React.createElement("div", null, renderAst(introHtmlAst)), React.createElement(ReadMoreTrigger, {
        collapseId: collapseId,
        showLessMessage: components.productDetailedReview.showLessMessage,
        showMoreMessage: components.productDetailedReview.showMoreMessage
      }), React.createElement("div", {
        className: "collapse multi-collapse",
        id: collapseId
      }, React.createElement("div", null, renderAst(fullCopyHtmlAst))))), React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-lg-6 mt-3"
      }, React.createElement("div", {
        className: "card pros rounded-top"
      }, React.createElement("div", {
        className: "card-header text-white h2"
      }, React.createElement("i", {
        className: "fa fa-plus-circle text-white",
        "aria-hidden": "true"
      }), ' ', "Pros"), React.createElement("ul", {
        className: "list-group list-group-flush"
      }, this.createListItemElements(pros ? pros : [], 'fa-check', productId + 'pro')))), React.createElement("div", {
        className: "col-lg-6 mt-3"
      }, React.createElement("div", {
        className: "card cons rounded-top"
      }, React.createElement("div", {
        className: "card-header text-white h2"
      }, React.createElement("i", {
        className: "fa fa-minus-circle text-white",
        "aria-hidden": "true"
      }), ' ', "Cons"), React.createElement("ul", {
        className: "list-group list-group-flush"
      }, this.createListItemElements(cons ? cons : [], 'fa-times', productId + 'con'))))), React.createElement("div", {
        className: "row p-3 align-items-center"
      }, React.createElement("div", {
        className: "col-12 align-middle text-center"
      }, React.createElement(AffiliateBuyButton, {
        seller: sellingPlatform,
        productUrl: buyingUrl,
        additionalCssClasses: 'btn-lg btn-block btn-pdr',
        affiliateId: affiliateId
      }, components.featureComparisonListItem.affiliateButtonLabel)))));
    }
  }]);

  return ProductDetailedReview;
}(React.Component);

var SideBar = /*#__PURE__*/function (_React$Component) {
  _inherits(SideBar, _React$Component);

  function SideBar() {
    _classCallCheck(this, SideBar);

    return _possibleConstructorReturn(this, _getPrototypeOf(SideBar).apply(this, arguments));
  }

  _createClass(SideBar, [{
    key: "getRelatedPosts",
    value: function getRelatedPosts(relatedPosts) {
      var sitePostSummaries = [];

      if (relatedPosts) {
        relatedPosts.forEach(function (post, i) {
          if (post.visible) {
            sitePostSummaries.push(React.createElement(TextPostSummary, {
              key: i,
              slug: post.slug,
              title: replacePlaceholders(post.title)
            }));
          }
        });
      }

      return sitePostSummaries;
    }
  }, {
    key: "getSidebarArticlesUnit",
    value: function getSidebarArticlesUnit(title, className, articleSummaries) {
      var articleUnit = null;

      if (articleSummaries.length >= 1) {
        articleUnit = [];
        articleUnit.push(React.createElement("div", {
          key: 0,
          className: className
        }, React.createElement("h2", {
          className: "display-5"
        }, title), articleSummaries));
      }

      return articleUnit;
    }
  }, {
    key: "render",
    value: function render() {
      var relatedPosts = this.props.relatedPosts;
      var relatedArticleSummaries = this.getRelatedPosts(relatedPosts);
      return React.createElement("div", null, this.getSidebarArticlesUnit("Related Articles", "related-articles", relatedArticleSummaries));
    }
  }]);

  return SideBar;
}(React.Component);

// The promise will resolve as soon as needed, keep resolving with the
// cached object.
var waitForRecaptcha = new Promise(function (resolve) {
  var interval = setInterval(function () {
    if (typeof window !== 'undefined' && typeof window.grecaptcha !== 'undefined') {
      clearInterval(interval);
      resolve(window.grecaptcha);
    }
  }, 1000);
});

var Recaptcha = /*#__PURE__*/function (_Component) {
  _inherits(Recaptcha, _Component);

  function Recaptcha(props) {
    var _this;

    _classCallCheck(this, Recaptcha);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Recaptcha).call(this, props));
    _this.state = {
      widget: null
    };
    _this._containerRef = null;
    return _this;
  }

  _createClass(Recaptcha, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._renderGrecaptcha();
    }
  }, {
    key: "reset",
    value: function reset() {
      var widget = this.state.widget;

      if (widget !== null) {
        window.grecaptcha.reset(widget);
      }
    }
  }, {
    key: "_renderGrecaptcha",
    value: function _renderGrecaptcha() {
      var _this2 = this;

      var _this$props = this.props,
          sitekey = _this$props.sitekey,
          theme = _this$props.theme,
          type = _this$props.type,
          size = _this$props.size,
          tabindex = _this$props.tabindex,
          hl = _this$props.hl,
          badge = _this$props.badge,
          verifyCallback = _this$props.verifyCallback,
          expiredCallback = _this$props.expiredCallback,
          onloadCallback = _this$props.onloadCallback;

      if (typeof window !== 'undefined') {
        if (window.innerWidth <= 568) {
          size = 'compact';
        }
      }

      waitForRecaptcha.then(function (grecaptcha) {
        var widget = grecaptcha.render(_this2._containerRef, {
          sitekey: sitekey,
          theme: theme,
          type: type,
          size: size,
          tabindex: tabindex,
          hl: hl,
          badge: badge,
          callback: verifyCallback,
          'expired-callback': expiredCallback
        });

        _this2.setState({
          widget: widget
        });
      });

      if (onloadCallback) {
        onloadCallback();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React.createElement("div", {
        ref: function ref(el) {
          return _this3._containerRef = el;
        }
      });
    }
  }]);

  return Recaptcha;
}(Component);

Recaptcha.defaultProps = {
  onloadCallback: undefined,
  verifyCallback: undefined,
  expiredCallback: undefined,
  theme: 'light',
  type: 'image',
  size: 'normal',
  tabindex: '0',
  hl: 'en',
  badge: 'bottomright'
};
var errorMessage = 'Hmm, something went wrong';

var RecaptureForm = /*#__PURE__*/function (_React$Component) {
  _inherits(RecaptureForm, _React$Component);

  function RecaptureForm(props) {
    var _this;

    _classCallCheck(this, RecaptureForm);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RecaptureForm).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "resetRecaptcha", function () {
      _this.recaptchaInstance.reset();

      _this.setState({
        recapture: ''
      });

      _this.attemptEnableSubmit('');
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var updatedFieldState = _objectSpread2({}, _this.state.fieldState, _defineProperty({}, event.target.id, event.target.value));

      _this.setState(_objectSpread2({}, _this.state, {
        fieldState: updatedFieldState
      }));

      _this.attemptEnableSubmit(_this.state.recapture);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", function (event) {
      event.preventDefault();
      event.stopPropagation();

      _this.setState({
        error: false
      });

      var form = document.getElementById('recaptureForm');
      form.classList.add('was-validated');

      var body = _objectSpread2({
        captcha: _this.state.recapture,
        type: _this.props.formType,
        language: 'en-GB'
      }, _this.state.fieldState, {
        body: _objectSpread2({}, _this.state.fieldState)
      });

      fetch(process.env.CONTACTUS_API, {
        method: 'post',
        body: JSON.stringify(body),
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json',
          'x-api-key': process.env.CONTACTUS_API_KEY
        }
      }).then(function (response) {
        return response.json();
      }).then(function (data) {
        if (data.code === 0 || data.code === 1) {
          _this.setState({
            success: true
          });
        } else {
          throw new Error(errorMessage);
        }
      })["catch"](function (error) {
        _this.setState({
          error: true,
          errorMessage: error.message
        });

        _this.resetRecaptcha();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "attemptEnableSubmit", function (recapture) {
      var form = document.getElementById('recaptureForm');

      if (form.checkValidity() === true && recapture.length > 0) {
        _this.setState({
          submitDisabled: false
        });
      } else {
        _this.setState({
          submitDisabled: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "verifyCallback", function (response) {
      _this.setState({
        recapture: response
      });

      _this.attemptEnableSubmit(response);
    });

    _defineProperty(_assertThisInitialized(_this), "recursiveMap", function (children, operation) {
      return React.Children.map(children, function (child) {
        if (!React.isValidElement(child)) {
          return child;
        }

        if (child.props.children) {
          child = React.cloneElement(child, {
            children: _this.recursiveMap(child.props.children, operation)
          });
        }

        return operation(child);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "cloneChildInput", function (child) {
      return React.cloneElement(child, {
        value: _this.state.fieldState[child.props.id],
        onChange: _this.handleChange
      });
    });

    var fieldState = {};

    _this.recursiveMap(_this.props.children, function (child) {
      if (child.type === 'textarea' || child.type === 'input') fieldState[child.props.id] = '';
    });

    _this.state = {
      submitDisabled: true,
      success: false,
      error: false,
      errorMessage: '',
      recapture: '',
      fieldState: _objectSpread2({}, fieldState)
    };
    return _this;
  }

  _createClass(RecaptureForm, [{
    key: "createForm",
    value: function createForm() {
      var _this2 = this;

      return React.createElement("form", {
        id: "recaptureForm",
        onSubmit: this.handleSubmit,
        noValidate: true
      }, React.createElement("div", {
        className: "form-group"
      }, this.createErrorMessage()), this.recursiveMap(this.props.children, this.cloneChildInput), React.createElement("div", {
        className: "form-group"
      }, React.createElement(Recaptcha, {
        ref: function ref(e) {
          return _this2.recaptchaInstance = e;
        },
        sitekey: process.env.RECAPTCHA_SECRET,
        verifyCallback: this.verifyCallback
      })), React.createElement("div", {
        className: "form-group"
      }, React.createElement("button", {
        type: "submit",
        className: "btn btn-primary",
        disabled: this.state.submitDisabled
      }, this.props.submitButtonLabel)));
    }
  }, {
    key: "createErrorMessage",
    value: function createErrorMessage() {
      var error = this.state.error ? '' : 'invisible';
      var classes = "alert alert-danger ".concat(error);
      return React.createElement("div", {
        className: classes,
        role: "alert"
      }, this.state.errorMessage);
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement("div", null, this.state.success ? this.props.successComponent() : this.createForm());
    }
  }]);

  return RecaptureForm;
}(React.Component);

var NewsletterSignUpForm = /*#__PURE__*/function (_React$Component) {
  _inherits(NewsletterSignUpForm, _React$Component);

  function NewsletterSignUpForm() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, NewsletterSignUpForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(NewsletterSignUpForm)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "successComponent", function () {
      var success = _this.props.success;
      return React.createElement("div", {
        className: "main-container"
      }, React.createElement("div", {
        className: "row justify-content-center no-gutters text-center"
      }, React.createElement("div", {
        className: "col-sm-8"
      }, React.createElement("h1", {
        className: "display-4 py-5"
      }, success ? success : "success"))));
    });

    return _this;
  }

  _createClass(NewsletterSignUpForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          lead = _this$props.lead,
          submit_label = _this$props.submit_label,
          name_label = _this$props.name_label,
          name_placeholder = _this$props.name_placeholder,
          email_label = _this$props.email_label,
          email_placeholder = _this$props.email_placeholder;
      return React.createElement("div", {
        className: "signup-form p-5 my-5"
      }, React.createElement("div", {
        className: "row justify-content-center"
      }, React.createElement("div", {
        className: "col-sm-8"
      }, React.createElement("h2", {
        className: "display-5 text-center"
      }, title ? title : "title"), React.createElement("p", {
        className: "lead"
      }, lead ? lead : "lead"))), React.createElement(RecaptureForm, {
        successComponent: this.successComponent,
        submitButtonLabel: submit_label ? submit_label : "submit_label",
        formType: "newsletter"
      }, React.createElement("div", {
        className: "form-group"
      }, React.createElement("label", {
        htmlFor: "name"
      }, name_label ? name_label : "name_label"), React.createElement("input", {
        type: "text",
        className: "form-control",
        id: "name",
        name: "name",
        placeholder: name_placeholder ? name_placeholder : "name_placeholder",
        required: true
      })), React.createElement("div", {
        className: "form-group"
      }, React.createElement("label", {
        htmlFor: "email"
      }, email_label ? email_label : "email_label"), React.createElement("input", {
        type: "email",
        className: "form-control",
        id: "email",
        name: "email",
        placeholder: email_placeholder ? email_placeholder : "email_placeholder",
        required: true
      }))));
    }
  }]);

  return NewsletterSignUpForm;
}(React.Component);

var CategoryBadge = /*#__PURE__*/function (_React$Component) {
  _inherits(CategoryBadge, _React$Component);

  function CategoryBadge() {
    _classCallCheck(this, CategoryBadge);

    return _possibleConstructorReturn(this, _getPrototypeOf(CategoryBadge).apply(this, arguments));
  }

  _createClass(CategoryBadge, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          slug = _this$props.slug;
      return React.createElement("a", {
        href: slug,
        className: "badge badge-primary text-white"
      }, title);
    }
  }]);

  return CategoryBadge;
}(React.Component);

var ScrollToTopOfPage = /*#__PURE__*/function (_React$Component) {
  _inherits(ScrollToTopOfPage, _React$Component);

  function ScrollToTopOfPage() {
    _classCallCheck(this, ScrollToTopOfPage);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScrollToTopOfPage).apply(this, arguments));
  }

  _createClass(ScrollToTopOfPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      setTimeout(function () {
        return window.scrollTo(0, 0);
      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ScrollToTopOfPage;
}(React.Component);

var SEOMetaTags = /*#__PURE__*/function (_React$Component) {
  _inherits(SEOMetaTags, _React$Component);

  function SEOMetaTags() {
    _classCallCheck(this, SEOMetaTags);

    return _possibleConstructorReturn(this, _getPrototypeOf(SEOMetaTags).apply(this, arguments));
  }

  _createClass(SEOMetaTags, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          description = _this$props.description,
          imageUrl = _this$props.imageUrl,
          path = _this$props.path,
          site = _this$props.site,
          structuredData = _this$props.structuredData;
      var canonicalUrl = site.siteMetadata.siteUrl + path;
      var fullTitle = title + '|' + site.siteMetadata.brand;
      var structuredDataElement = null;

      if (structuredData) {
        structuredDataElement = React.createElement("script", {
          type: "application/ld+json"
        }, JSON.stringify(structuredData));
      }

      return React.createElement(Helmet, null, React.createElement("link", {
        rel: "canonical",
        href: canonicalUrl
      }), React.createElement("title", null, fullTitle), React.createElement("meta", {
        name: "description",
        content: description
      }), React.createElement("meta", {
        property: "og:title",
        content: fullTitle
      }), React.createElement("meta", {
        property: "og:type",
        content: "article"
      }), React.createElement("meta", {
        property: "og:description",
        content: description
      }), React.createElement("meta", {
        property: "og:image",
        content: 'https:' + imageUrl
      }), React.createElement("meta", {
        property: "og:url",
        content: canonicalUrl
      }), React.createElement("meta", {
        name: "twitter:card",
        content: "summary"
      }), React.createElement("meta", {
        name: "twitter:site",
        content: '@' + site.siteMetadata.twitter
      }), React.createElement("meta", {
        name: "twitter:title",
        content: fullTitle
      }), React.createElement("meta", {
        property: "twitter:image",
        content: 'https:' + imageUrl
      }), React.createElement("script", {
        type: "text/javascript"
      }, "\n\n            var addthis_share = addthis_share || {}\n            addthis_share = {\n              url: \"".concat(canonicalUrl, "\",\n              title: \"").concat(title ? title.trim() : '', "\",\n              description: \"").concat(description ? description.trim() : '', "\",\n              media: \"").concat(imageUrl, "\",\n              passthrough : {\n                twitter: {\n                  via: \"").concat(site.siteMetadata.twitter, "\"\n                }\n              },\n              url_transforms : {\n                shorten: {\n                  twitter: 'bitly'\n                }\n              },\n              shorteners : {\n                bitly : {}\n              }\n            }\n\n            var addthis_config = addthis_config||{};\n            addthis_config.data_track_addressbar = false;\n            addthis_config.data_track_clickback = false;\n            ")), structuredDataElement);
    }
  }]);

  return SEOMetaTags;
}(React.Component);

var ShareButtons = /*#__PURE__*/function (_React$Component) {
  _inherits(ShareButtons, _React$Component);

  function ShareButtons() {
    _classCallCheck(this, ShareButtons);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShareButtons).apply(this, arguments));
  }

  _createClass(ShareButtons, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          url = _this$props.url,
          hashtag = _this$props.hashtag,
          title = _this$props.title,
          iconSize = _this$props.iconSize;
      return React.createElement("div", null, React.createElement(FacebookShareButton, {
        className: "social-network",
        url: url,
        hashtag: '#' + hashtag
      }, React.createElement(FacebookIcon, {
        size: iconSize,
        round: true
      })), React.createElement(TwitterShareButton, {
        className: "social-network",
        url: url,
        hashtags: [hashtag]
      }, React.createElement(TwitterIcon, {
        size: iconSize,
        round: true
      })), React.createElement(PocketShareButton, {
        className: "social-network",
        url: url
      }, React.createElement(PocketIcon, {
        size: iconSize,
        round: true
      })), React.createElement(EmailShareButton, {
        className: "social-network",
        url: url,
        title: 'Thought you might like ' + title + ', from The Climbing Guy'
      }, React.createElement(EmailIcon, {
        size: iconSize,
        round: true
      })));
    }
  }]);

  return ShareButtons;
}(React.Component);

var ContentfulSitePost = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentfulSitePost, _React$Component);

  function ContentfulSitePost() {
    _classCallCheck(this, ContentfulSitePost);

    return _possibleConstructorReturn(this, _getPrototypeOf(ContentfulSitePost).apply(this, arguments));
  }

  _createClass(ContentfulSitePost, [{
    key: "categories",
    value: function categories(_categories) {
      var categoryBadges = [];

      if (_categories) {
        _categories.forEach(function (item, i) {
          categoryBadges.push(React.createElement(CategoryBadge, {
            title: replacePlaceholders(item.title),
            slug: item.slug
          }));
        });
      }

      return categoryBadges;
    }
  }, {
    key: "getAuthorProfileLinks",
    value: function getAuthorProfileLinks(authors) {
      var authorLinks = [];

      if (authors.length > 0) {
        authorLinks.push(React.createElement("span", {
          key: 0
        }, "Written By: "));
        authors.forEach(function (author, index) {
          authorLinks.push(React.createElement(AuthorProfileLink, {
            key: index + 1,
            authorSlug: author.slug,
            authorName: author.name
          }));

          if (index < authors.length - 1) {
            authorLinks.push(React.createElement("span", {
              key: index + "-A"
            }, " and "));
          }
        });
      }

      return authorLinks;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          htmlAst = _this$props.htmlAst,
          authors = _this$props.authors,
          publishDate = _this$props.publishDate,
          createdAt = _this$props.createdAt,
          updatedAt = _this$props.updatedAt,
          shareImage = _this$props.shareImage,
          slug = _this$props.slug,
          description = _this$props.description,
          site = _this$props.site,
          categories = _this$props.categories;
      var renderAst = new rehypeReact({
        createElement: React.createElement,
        components: {
          tip: Tip,
          leadparagraph: LeadParagraph
        }
      }).Compiler;
      var modifiedTitle = replacePlaceholders(title);
      var modifiedDescription = replacePlaceholders(description);
      return React.createElement("div", null, React.createElement(SEOMetaTags, {
        path: slug,
        site: site,
        title: modifiedTitle,
        description: modifiedDescription,
        imageUrl: shareImage,
        structuredData: JsonLdArticle.generate(site.siteMetadata.siteUrl, shareImage, site.siteMetadata.siteUrl + slug, modifiedTitle, createdAt, publishDate, updatedAt, authors[0].name, site.siteMetadata.brand, site.siteMetadata.siteUrl + "/icons/apple-icon-60x60.png", "60", "60")
      }), React.createElement(Helmet, null, React.createElement("script", {
        src: "//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=66ff0a4a-fd7b-40a9-b9e5-2030188e5e63",
        async: true
      })), React.createElement("div", {
        className: "article-wrap"
      }, React.createElement("div", {
        className: "page-header"
      }, React.createElement("h1", {
        className: "display-4"
      }, modifiedTitle), React.createElement("div", null, this.getAuthorProfileLinks(authors)), React.createElement(PostDate, {
        dateLastModified: updatedAt
      }), React.createElement("div", null, this.categories(categories)), React.createElement(ShareButtons, {
        url: site.siteMetadata.siteUrl + slug,
        hashtag: "rockclimbing",
        title: modifiedTitle,
        iconSize: 40
      })), React.createElement("div", {
        className: "page-content"
      }, renderAst(htmlAst)), React.createElement("div", {
        className: "float-right"
      }, React.createElement(ShareButtons, {
        url: site.siteMetadata.siteUrl + slug,
        hashtag: "rockclimbing",
        title: modifiedTitle,
        iconSize: 64
      }))));
    }
  }]);

  return ContentfulSitePost;
}(React.Component);

var ContentfulSitePage = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentfulSitePage, _React$Component);

  function ContentfulSitePage() {
    _classCallCheck(this, ContentfulSitePage);

    return _possibleConstructorReturn(this, _getPrototypeOf(ContentfulSitePage).apply(this, arguments));
  }

  _createClass(ContentfulSitePage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          htmlAst = _this$props.htmlAst,
          shareImage = _this$props.shareImage,
          slug = _this$props.slug,
          description = _this$props.description,
          site = _this$props.site;
      var renderAst = new rehypeReact({
        createElement: React.createElement,
        components: {
          tip: Tip,
          leadparagraph: LeadParagraph
        }
      }).Compiler;
      var modifiedTitle = replacePlaceholders(title);
      var modifiedDescription = replacePlaceholders(description);
      return React.createElement("div", null, React.createElement(SEOMetaTags, {
        path: slug,
        site: site,
        title: modifiedTitle,
        description: modifiedDescription,
        imageUrl: shareImage
      }), React.createElement("div", {
        className: "row py-3"
      }, React.createElement("h1", {
        className: "display-4"
      }, modifiedTitle)), React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col"
      }, React.createElement("div", null, renderAst(htmlAst)), React.createElement("div", {
        className: "float-right"
      }))));
    }
  }]);

  return ContentfulSitePage;
}(React.Component);

var ContentfulSitePerson = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentfulSitePerson, _React$Component);

  function ContentfulSitePerson() {
    _classCallCheck(this, ContentfulSitePerson);

    return _possibleConstructorReturn(this, _getPrototypeOf(ContentfulSitePerson).apply(this, arguments));
  }

  _createClass(ContentfulSitePerson, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          htmlAst = _this$props.htmlAst,
          fluidImage = _this$props.fluidImage,
          imageSrcUrl = _this$props.imageSrcUrl,
          slug = _this$props.slug,
          description = _this$props.description,
          site = _this$props.site;
      var renderAst = new rehypeReact({
        createElement: React.createElement,
        components: {
          tip: Tip,
          leadparagraph: LeadParagraph
        }
      }).Compiler;
      return React.createElement("div", null, React.createElement(SEOMetaTags, {
        path: slug,
        site: site,
        title: title,
        description: description,
        imageUrl: imageSrcUrl
      }), React.createElement("div", {
        className: "row py-3"
      }, React.createElement("h1", {
        className: "display-4"
      }, title)), React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-md-4"
      }, React.createElement(Img, {
        fluid: fluidImage
      })), React.createElement("div", {
        className: "col-md-8"
      }, React.createElement("div", null, renderAst(htmlAst)))));
    }
  }]);

  return ContentfulSitePerson;
}(React.Component);

var RoundupListItem = /*#__PURE__*/function (_React$Component) {
  _inherits(RoundupListItem, _React$Component);

  function RoundupListItem() {
    _classCallCheck(this, RoundupListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(RoundupListItem).apply(this, arguments));
  }

  _createClass(RoundupListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          brand = _this$props.brand,
          shortTitle = _this$props.shortTitle,
          ratings = _this$props.ratings,
          image = _this$props.image,
          sellingPlatform = _this$props.sellingPlatform,
          buyingUrl = _this$props.buyingUrl,
          affiliateId = _this$props.affiliateId,
          rank = _this$props.rank;
      return React.createElement("div", {
        className: "roundup-list-item"
      }, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-12"
      }, React.createElement("p", {
        className: "display-6 text-center text-md-left"
      }, "#" + rank + " " + brand + " " + shortTitle))), React.createElement("div", {
        className: "row align-items-center"
      }, React.createElement("div", {
        className: "offset-3 col-6 offset-md-0 col-md-2 text-center p-0"
      }, React.createElement(Img, {
        fluid: image,
        style: {
          height: "150px"
        },
        imgStyle: {
          objectFit: "contain"
        }
      })), React.createElement("div", {
        className: "col-12 col-md-10 mt-3 mt-md-0"
      }, React.createElement("div", {
        className: "row"
      }, React.createElement("div", {
        className: "col-12 col-md-7"
      }, React.createElement("ul", {
        className: "list-unstyled"
      }, React.createElement(RatingsComponent, {
        ratings: ratings,
        ratingCountToDisplay: 1,
        horizontal: true
      }))), React.createElement("div", {
        className: "offset-2 col-8 col-md-3"
      }, React.createElement(AffiliateBuyButton, {
        productUrl: buyingUrl,
        seller: sellingPlatform,
        additionalCssClasses: "btn-block btn-rli",
        affiliateId: affiliateId
      }, components.roundupListItem.affiliateButtonLabel))))), React.createElement("div", {
        className: "row align-items-center"
      }, React.createElement("div", {
        className: "col-12 text-center mt-3 mt-md-0"
      }, React.createElement(InteralSectionLink, {
        shortTitle: shortTitle
      }, "Detailed Review", " ", React.createElement("i", {
        className: "fa fa-chevron-down",
        "aria-hidden": "true"
      })))));
    }
  }]);

  return RoundupListItem;
}(React.Component);

var ContentfulSiteProductRoundUp = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentfulSiteProductRoundUp, _React$Component);

  function ContentfulSiteProductRoundUp() {
    _classCallCheck(this, ContentfulSiteProductRoundUp);

    return _possibleConstructorReturn(this, _getPrototypeOf(ContentfulSiteProductRoundUp).apply(this, arguments));
  }

  _createClass(ContentfulSiteProductRoundUp, [{
    key: "categories",
    value: function categories(_categories) {
      var categoryBadges = [];

      if (_categories) {
        _categories.forEach(function (item, i) {
          categoryBadges.push(React.createElement(CategoryBadge, {
            title: replacePlaceholders(item.title),
            slug: item.slug
          }));
        });
      }

      return categoryBadges;
    }
  }, {
    key: "getAuthorProfileLinks",
    value: function getAuthorProfileLinks(authors) {
      var authorLinks = [];

      if (authors.length > 0) {
        authorLinks.push(React.createElement("span", {
          key: 0
        }, "Written By: "));
        authors.forEach(function (author, index) {
          authorLinks.push(React.createElement(AuthorProfileLink, {
            key: index + 1,
            authorSlug: author.slug,
            authorName: author.name
          }));

          if (index < authors.length - 1) {
            authorLinks.push(React.createElement("span", {
              key: index + "-A"
            }, " and "));
          }
        });
      }

      return authorLinks;
    }
  }, {
    key: "createRoundUpListItems",
    value: function createRoundUpListItems(products, affiliateId) {
      var items = [];
      products.forEach(function (product, index) {
        var ratings = collectRatings(product);
        items.push(React.createElement(RoundupListItem, {
          key: index,
          rank: index + 1,
          brand: product.brand,
          shortTitle: product.shortTitle,
          ratings: ratings,
          image: product.images[0].fluid,
          sellingPlatform: product.sellingPlatform,
          buyingUrl: product.buyingUrl,
          affiliateId: affiliateId
        }));
        items.push(React.createElement("hr", {
          key: "hr" + index
        }));
      });

      if (items.length > 1) {
        items.splice(-1);
      }

      return items;
    }
  }, {
    key: "createProductDetailedReviews",
    value: function createProductDetailedReviews(products, topPickBadge, affiliateId) {
      var productDetailReviews = [];
      products.forEach(function (product, index) {
        productDetailReviews.push(React.createElement("div", {
          key: product.id + "hl" + index,
          id: kebabCase(product.shortTitle),
          className: "anchored-element"
        }));
        var ratings = collectRatings(product);
        productDetailReviews.push(React.createElement(ProductDetailedReview, {
          rank: index + 1,
          key: product.id + "pdr" + index,
          topPickBadge: topPickBadge,
          affiliateId: affiliateId,
          productId: product.id,
          shortTitle: product.shortTitle,
          longTitle: product.longTitle,
          brand: product.brand,
          awardLabel: product.award ? product.award.label : "",
          productFixedImage: product.images[0].fluid,
          ratings: ratings,
          introHtmlAst: product.introduction.childMarkdownRemark.htmlAst,
          fullCopyHtmlAst: product.fullCopy.childMarkdownRemark.htmlAst,
          pros: product.pros,
          cons: product.cons,
          sellingPlatform: product.sellingPlatform,
          buyingUrl: product.buyingUrl
        }));
      });
      return productDetailReviews;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          slot1 = _this$props.slot1,
          slot2 = _this$props.slot2,
          slot3 = _this$props.slot3,
          slot4 = _this$props.slot4,
          slot5 = _this$props.slot5,
          authors = _this$props.authors,
          publishDate = _this$props.publishDate,
          createdAt = _this$props.createdAt,
          updatedAt = _this$props.updatedAt,
          shareImage = _this$props.shareImage,
          slug = _this$props.slug,
          description = _this$props.description,
          site = _this$props.site,
          categories = _this$props.categories,
          products = _this$props.products,
          topPickBadgeFluid = _this$props.topPickBadgeFluid,
          affiliateId = _this$props.affiliateId,
          attributesToDisplay = _this$props.attributesToDisplay;
      var renderAst = new rehypeReact({
        createElement: React.createElement,
        components: {
          tip: Tip,
          leadparagraph: LeadParagraph
        }
      }).Compiler;
      var winner = products[0];
      var winnerRatings = collectRatings(winner);
      var roundupItems = this.createRoundUpListItems(products, affiliateId);
      var details = this.createProductDetailedReviews(products, topPickBadgeFluid, affiliateId);
      var person = JsonLdPerson.generate(authors[0].name, site.siteMetadata.siteUrl + authors[0].slug);
      var modifiedTitle = replacePlaceholders(title);
      var modifiedDescription = replacePlaceholders(description);
      var jsonLdEntries = [JsonLdArticle.generate(site.siteMetadata.siteUrl, shareImage, site.siteMetadata.siteUrl + slug, modifiedTitle, createdAt, publishDate, updatedAt, authors[0].name, site.siteMetadata.brand, site.siteMetadata.siteUrl + "/icons/apple-icon-60x60.png", "60", "60"), JsonLdProduct.generate(winner.images[0].fixedHeight300.src, winner.brand, winner.longTitle, modifiedDescription, winnerRatings[0].value, winner.buyingUrl, updatedAt, authors[0].name, site.siteMetadata.brand, site.siteMetadata.siteUrl + "/icons/apple-icon-60x60.png", "60", "60")];
      return React.createElement("div", null, React.createElement(SEOMetaTags, {
        path: slug,
        site: site,
        title: modifiedTitle,
        description: modifiedDescription,
        imageUrl: shareImage,
        structuredData: jsonLdEntries
      }), React.createElement(Helmet, null, React.createElement("script", {
        src: "//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=66ff0a4a-fd7b-40a9-b9e5-2030188e5e63",
        async: true
      })), React.createElement("div", {
        className: "article-wrap"
      }, React.createElement("div", {
        className: "page-header"
      }, React.createElement("h1", {
        className: "display-4"
      }, modifiedTitle), React.createElement("div", null, this.getAuthorProfileLinks(authors)), React.createElement(PostDate, {
        dateLastModified: updatedAt
      }), React.createElement("div", null, this.categories(categories)), React.createElement(ShareButtons, {
        url: site.siteMetadata.siteUrl + slug,
        hashtag: "rockclimbing",
        title: modifiedTitle,
        iconSize: 40
      })), slot1 ? React.createElement("div", {
        className: "page-content"
      }, renderAst(slot1)) : null, React.createElement(RoundupWinner, {
        shortTitle: winner.shortTitle,
        longTitle: winner.longTitle,
        brand: winner.brand,
        productFluidImage: winner.images[0].fluid,
        topPickBadgeFluid: topPickBadgeFluid,
        ratings: winnerRatings,
        winnerPros: winner.pros,
        sellingPlatform: winner.sellingPlatform,
        buyingUrl: winner.buyingUrl,
        affiliateId: affiliateId
      }), slot2 ? React.createElement("div", {
        className: "page-content"
      }, renderAst(slot2)) : null, roundupItems, slot3 ? React.createElement("div", {
        className: "page-content"
      }, renderAst(slot3)) : null, React.createElement(FeatureComparisonTable, {
        attributesToDisplay: attributesToDisplay,
        products: products,
        affiliateId: affiliateId
      }), slot4 ? React.createElement("div", {
        className: "page-content"
      }, renderAst(slot4)) : null, details, slot5 ? React.createElement("div", {
        className: "page-content"
      }, renderAst(slot5)) : null, React.createElement("div", null), React.createElement("div", {
        className: "float-right"
      }, React.createElement(ShareButtons, {
        url: site.siteMetadata.siteUrl + slug,
        hashtag: "rockclimbing",
        title: modifiedTitle,
        iconSize: 64
      }))));
    }
  }]);

  return ContentfulSiteProductRoundUp;
}(React.Component);

/**
 * @deprecated use combinePostsAndRoundups in favour of this
 */
function getPostAndRoundUpCombinedList(allPosts, allProductRoundUps) {
  var postIndex = 0,
      roundUpIndex = 0;
  var nextPost, nextRoundUp;
  var process = true;
  var combinedList = [];

  while (process) {
    if (postIndex < allPosts.length) {
      if (!nextPost) {
        nextPost = allPosts[postIndex];
        postIndex++;
      }
    }

    if (roundUpIndex < allProductRoundUps.length) {
      if (!nextRoundUp) {
        nextRoundUp = allProductRoundUps[roundUpIndex];
        roundUpIndex++;
      }
    }

    if (nextPost && nextRoundUp) {
      var nextPostDate = new Date(nextPost.post.publishDateISO);
      var nextRoundupDate = new Date(nextRoundUp.post.publishDateISO);

      if (nextPostDate <= nextRoundupDate) {
        combinedList.push(nextRoundUp);
        nextRoundUp = null;
      } else {
        combinedList.push(nextPost);
        nextPost = null;
      }
    } else if (nextPost) {
      combinedList.push(nextPost);
      nextPost = null;
    } else if (nextRoundUp) {
      combinedList.push(nextRoundUp);
      nextRoundUp = null;
    } else {
      process = false;
    }
  }

  return combinedList;
}

function combinePostsAndRoundups(posts, roundUps) {
  var result = [];
  posts = posts ? posts : [];
  roundUps = roundUps ? roundUps : [];
  result = [].concat(_toConsumableArray(posts), _toConsumableArray(roundUps)).sort(function (a, b) {
    return new Date(b.updatedAtISO) - new Date(a.updatedAtISO);
  });
  return result;
}

var messages = {
  categorycomponent: {
    articlesHeading: "Articles",
    readAll: "Read all"
  }
};

var ContentfulCategory = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentfulCategory, _React$Component);

  function ContentfulCategory() {
    _classCallCheck(this, ContentfulCategory);

    return _possibleConstructorReturn(this, _getPrototypeOf(ContentfulCategory).apply(this, arguments));
  }

  _createClass(ContentfulCategory, [{
    key: "createCategorySummaries",
    value: function createCategorySummaries(categories, parent) {
      var _this = this;

      var categoriesSummaries = [];

      if (categories) {
        categories.forEach(function (element, i) {
          var combinedPosts = combinePostsAndRoundups(element.blog_post, element.productroundup);
          combinedPosts = combinedPosts.filter(function (element) {
            return element.visible === true;
          });
          combinedPosts = combinedPosts.length > 3 ? combinedPosts.slice(0, 3) : combinedPosts;

          if (combinedPosts.length > 0) {
            categoriesSummaries.push(React.createElement("div", {
              className: "col-12",
              key: kebabCase(element.slug) + i
            }, React.createElement(LazyLoad, {
              height: 500,
              offset: 500,
              once: true
            }, React.createElement(Link, {
              to: element.slug
            }, React.createElement("div", {
              className: "row align-items-center"
            }, React.createElement("div", {
              className: "col-md-6"
            }, React.createElement("h2", {
              className: "display-5"
            }, replacePlaceholders(element.title))), React.createElement("div", {
              className: "col-md-6"
            }, React.createElement("div", {
              className: "float-right"
            }, messages.categorycomponent.readAll)))), _this.createPostSummaries(combinedPosts)), React.createElement("hr", null)));
          }
        });
      }

      return categoriesSummaries.length > 0 ? React.createElement("div", {
        className: "row"
      }, categoriesSummaries) : null;
    }
  }, {
    key: "createPostSummaries",
    value: function createPostSummaries(posts) {
      var postSummaries = [];

      if (posts) {
        posts.forEach(function (element, i) {
          postSummaries.push(React.createElement("div", {
            className: "col-md-4",
            key: kebabCase(element.slug) + i
          }, React.createElement(LazyLoad, {
            height: 500,
            offset: 500,
            once: true
          }, React.createElement(SitePostSummary, {
            title: element.title,
            slug: element.slug,
            authors: element.authors,
            dateLastModified: element.updatedAt,
            description: element.description.childMarkdownRemark.rawMarkdownBody,
            shareImage: element.shareImage.fixed_1200x675,
            horizontal: true
          }))));
        });
      }

      return postSummaries.length > 0 ? React.createElement("div", {
        className: "row"
      }, postSummaries) : null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          slot1 = _this$props.slot1,
          slot2 = _this$props.slot2,
          publishDate = _this$props.publishDate,
          createdAt = _this$props.createdAt,
          updatedAt = _this$props.updatedAt,
          shareImage = _this$props.shareImage,
          slug = _this$props.slug,
          description = _this$props.description,
          site = _this$props.site,
          subCategories = _this$props.subCategories,
          blogPosts = _this$props.blogPosts,
          productRoundups = _this$props.productRoundups;
      var renderAst = new rehypeReact({
        createElement: React.createElement,
        components: {
          tip: Tip,
          leadparagraph: LeadParagraph
        }
      }).Compiler;
      var combinedPosts = combinePostsAndRoundups(blogPosts, productRoundups);
      var categorySummaries = this.createCategorySummaries(subCategories);
      var postSummaries = this.createPostSummaries(combinedPosts);
      var modifiedTitle = replacePlaceholders(title);
      var modifiedDescription = replacePlaceholders(description);
      return React.createElement("div", null, React.createElement(SEOMetaTags, {
        path: slug,
        site: site,
        title: modifiedTitle,
        description: modifiedDescription,
        imageUrl: shareImage
      }), React.createElement("div", {
        className: "article-wrap"
      }, React.createElement("div", {
        className: "page-header"
      }, React.createElement("h1", {
        className: "display-4"
      }, modifiedTitle)), slot1 ? React.createElement("div", {
        className: "page-content"
      }, renderAst(slot1)) : null, categorySummaries ? categorySummaries : null, React.createElement("br", null), postSummaries ? React.createElement("h2", {
        className: "display-5"
      }, messages.categorycomponent.articlesHeading) : null, postSummaries ? postSummaries : null, slot2 ? React.createElement("div", {
        className: "page-content"
      }, renderAst(slot2)) : null, React.createElement("div", null)));
    }
  }]);

  return ContentfulCategory;
}(React.Component);

export { AuthorProfileLink, CategoryBadge, ContentfulCategory, ContentfulSitePage, ContentfulSitePerson, ContentfulSitePost, ContentfulSiteProductRoundUp, FeatureComparisonListItem, FeatureComparisonTable, InteralSectionLink, JsonLdArticle, JsonLdItemList, JsonLdOrganization, JsonLdPerson, JsonLdProduct, JsonLdReview, JsonLdSiteNavigation, JsonLdWebSite, LeadParagraph, NewsletterSignUpForm, PostDate, ProductDetailedReview, RatingsComponent, ReadMoreTrigger, Recaptcha, RecaptureForm, RoundupWinner, SEOMetaTags, ScrollToTopOfPage, SideBar, SitePostSummary, StarRating, TextPostSummary, Tip, getPostAndRoundUpCombinedList, replacePlaceholders };